<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="row">
          <div class="col-12 text-center">
            <img
              src="@/assets/images/mascot-logo.png"
              alt
              style="height: calc(50vh)"
            />
            <!-- class="img-fluid" -->
          </div>

          <!-- <div class="col-12 text-center mt-4" v-if="!isAuthStateLoading">
            <button
              class="btn btn-on relative"
              style="width: 260px"
              @click="onOauthSigninClick"
            >
              GET STARTED
              <i
                class="fas fa-chevron-right absolute"
                style="right: 10px; top: 10px"
              />
            </button>
          </div> -->
          <div class="col-12 text-center mt-4" v-if="!isAuthStateLoading">
            <button
              class="btn btn-on relative text-left"
              style="width:260px"
              @click="onKeyCloakSigninClick"
            >
            <img src="@/assets/images/keycloak.webp" class="mr-3" width="25px"/>
              GET STARTED WITH SSO
              <i
                class="fas fa-chevron-right absolute"
                style="right: 10px;top: 10px;"
              />
            </button>
          </div>
          <div class="col-12 login-loading mt-4" v-show="isAuthStateLoading">
            <div class="row">
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-success" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-success"
                  style="margin-top: -25px"
                >
                  <strong>O</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                  ></div>
                </div>
                <div
                  class="row justify-content-center text-secondary"
                  style="margin-top: -25px"
                >
                  <strong>F</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-danger" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-danger"
                  style="margin-top: -25px"
                >
                  <strong>F</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-warning" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-warning"
                  style="margin-top: -25px"
                >
                  <strong>I</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-info" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-info"
                  style="margin-top: -25px"
                >
                  <strong>C</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-dark" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-dark"
                  style="margin-top: -25px"
                >
                  <strong>E</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-primary" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-primary"
                  style="margin-top: -25px"
                >
                  <strong>M</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-muted" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-muted"
                  style="margin-top: -25px"
                >
                  <strong>A</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-danger" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-danger"
                  style="margin-top: -25px"
                >
                  <strong>T</strong>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-center">
                  <div class="spinner-border text-success" role="status"></div>
                </div>
                <div
                  class="row justify-content-center text-success"
                  style="margin-top: -25px"
                >
                  <strong>E</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="isAuthError">
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-4"
              dismissible
              >{{ authError }}</b-alert
            >
          </div>
        </div>
        <!-- end card -->
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/auth";
import axios from "axios";
import { authMethods, layoutMethods } from "@/state/helpers";
import * as jwt from "@/helpers/utils/jwt";
import appConfig from "@/app.config";
import * as date from "@/helpers/utils/date";

export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      authError: null,
      isAuthStateLoading: true,
      isAuthError: false,
      oauthConfig: {
        clientId: process.env.VUE_APP_OAUTH_CLIENT_ID,
        clientSecret: process.env.VUE_APP_OAUTH_CLIENT_SECRET,
        grantType: "authorization_code",
        redirect_url: `${process.env.VUE_APP_BASE_URL}/login`,
      },
      keyCloakConfig: {
        clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
        grantType: 'authorization_code',
        redirect_url: `${process.env.VUE_APP_BASE_URL}/login/kc/callback`,
      },
    };
  },
  computed: {},
  created() {},
  async mounted() {
    if (
      this.$route.query.authorize_code &&
      this.$route.query.access_token_url &&
      this.$route.query.secret_key
    ) {
      this.$cookies.set(".oauth.sk", this.$route.query.secret_key);
      this.getAccessToken(
        this.$route.query.authorize_code,
        this.$route.query.access_token_url
      );
    } else {
      await this.checkCookie();
    }
  },
  methods: {
    ...authMethods,
    ...layoutMethods,
    onKeyCloakSigninClick() {
      this.timerCount = 10
      
      let scopes = 'openid'
      let redirect_url = encodeURIComponent(this.keyCloakConfig.redirect_url)
      // 'https://du-kc-authen.ofm.co.th/realms/CHMS/protocol/openid-connect/auth?response_type=code&client_id=pim-client&redirect_uri=https%3A%2F%2Foauth.pstmn.io%2Fv1%2Fcallback'
      let oauthLocation = `${process.env.VUE_APP_BASE_URL_KEYCLOAK}?response_type=code&client_id=${this.keyCloakConfig.clientId}&redirect_uri=${redirect_url}&scopes=${scopes}`
      window.location.href = oauthLocation
    },
    async checkCookie() {
      let accessToken = this.$cookies.get(".at");
      //console.log(accessToken);
      if (accessToken) {
        if (await jwt.validateExpireAccessToken(accessToken)) {
          this.authen(accessToken);
          return;
        }
      }
      this.isAuthStateLoading = false;
    },
    getAccessToken(authorize_code, access_token_url) {
      const data = JSON.stringify({
        client_id: this.oauthConfig.clientId,
        client_secret: this.oauthConfig.clientSecret,
        grant_type: this.oauthConfig.grantType,
        authorize_code: authorize_code,
      });
      //console.log(data);
      axios({
        headers: {
          "Content-Type": "application/json",
        },
        method: "Post",
        data: data,
        url: `${access_token_url}`,
      }).then(
        (result) => {
          // console.log(result.data)
          if (result.data.refresh_token && result.data.access_token) {
            var decodeRf = jwt.getUserInfo(result.data.refresh_token);
            var decodeAt = jwt.getUserInfo(result.data.access_token);
            // var xxx = date.differentTimeMinutes(decodeAt.exp);
            //           console.log('decodeAt',decodeAt)
            //           console.log('date.differentTimeMinutes(decodeRf.exp)',xxx)

            this.$cookies.set(
              ".oauth.rt",
              result.data.refresh_token,
              date.differentTimeMinutes(decodeRf.exp) * 60
            );
            this.$cookies.set(
              ".at",
              result.data.access_token,
              date.differentTimeMinutes(decodeAt.exp) * 60
            );
            this.authen(result.data.access_token);
            if (result.data.info && result.data.info != null) {
              let info = JSON.stringify({
                name: result.data.info.name,
                email: result.data.info.email,
                photo: result.data.info.photo,
              });
              this.$cookies.set(
                ".oauth.usr",
                info,
                date.differentTimeMinutes(decodeAt.exp) * 60
              );
            }
          }
        },
        (error) => {
          console.log(error.response);
        }
      );
    },
    authen(accessToken) {
      axios({
        headers: {
          "Content-Type": "application/json",
        },
        method: "Post",
        data: {
          access_token: accessToken,
        },
        url: `${process.env.VUE_APP_BASE_API}api/v1/Authentications/signin`,
      }).then(
        (result) => {
          this.setIsAuthenticated({ isAuthenticated: true });
          this.setAccessToken({ accessToken: result.data.token });
          this.setAuthProvider({ authProvider: 'ofmconnect' });
          // localStorage.setItem('.psgauth.at', result.data.token)

          this.changeLayoutType({ layoutType: "horizontal" });

          this.$router.push({ path: "/" });
        },
        (error) => {
          console.log(error.response);
        }
      );
    },
    onOauthSigninClick() {
      var sk = this.$cookies.get(".oauth.sk");
      let queryString = "";
      if (sk) {
        queryString = sk;
      }
      let scopes = "default,email,employee";
      let redirect_url = encodeURIComponent(this.oauthConfig.redirect_url);
      let oauthlocation = `${process.env.VUE_APP_BASE_URL_OAuth}authentication/signin?client_id=${this.oauthConfig.clientId}&redirect_uri=${redirect_url}&scopes=${scopes}`;
      window.location.href = oauthlocation;
    },
  },
};
</script>
<style>
body {
  background-color: #fff;
}
</style>
